/* eslint-disable camelcase */
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import dayjs from 'libs/dayjs';import { fontFamily } from 'components/PDF2/assets';

dayjs.locale('es');

const styles = StyleSheet.create({
  voucherData: {
    flexDirection: 'column',
    fontFamily: 'Helvetica',
    fontSize: 11,
  },
  dataSection: {
    marginBottom: '1cm',
  },
  sectionTitle: {
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    marginBottom: '0.3cm',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  gridRow: {
    flexDirection: 'row',
    marginBottom: '0.4cm',
    gap: '0.5cm',
  },
  gridItem: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  gridLabel: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    marginBottom: '0.1cm',
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
  },
  gridValue: {
    fontSize: 11,
    fontFamily: 'Helvetica',
    color: '#2c3e50',
    padding: '0.2cm',
    backgroundColor: '#f8f9fa',
    borderRadius: '0.2cm',
    border: '1px solid #e8e8e8',
    textTransform: 'capitalize',
  },
  fullWidthItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '0.4cm',
  },
  fullWidthLabel: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    marginBottom: '0.1cm',
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
  },
  fullWidthValue: {
    fontSize: 11,
    fontFamily: 'Helvetica',
    color: '#2c3e50',
    padding: '0.2cm',
    backgroundColor: '#f8f9fa',
    borderRadius: '0.2cm',
    border: '1px solid #e8e8e8',
    textTransform: 'capitalize',
  },
});

function VoucherData(props) {
  const {
    recepcionist_name,
    finish_state,
    client_name,
    reason,
    attention_init,
    attention_finish,
    client_rut,
    equipment,
    specialist_name,
    date,
  } = props;
  return (
    <View style={styles.voucherData}>
      {/* Información de Personas */}
      <View style={styles.dataSection}>
        <Text style={styles.sectionTitle}>Información de Personas</Text>
        <View style={styles.gridRow}>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Especialista</Text>
            <Text style={styles.gridValue}>{specialist_name}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Recibe</Text>
            <Text style={styles.gridValue}>{recepcionist_name}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Cliente</Text>
            <Text style={styles.gridValue}>{client_name}</Text>
          </View>
        </View>
      </View>

      {/* Información de Fechas y Datos */}
      <View style={styles.dataSection}>
        <Text style={styles.sectionTitle}>Información de Fechas y Datos</Text>
        <View style={styles.gridRow}>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Tipo</Text>
            <Text style={styles.gridValue}>{reason}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Fecha</Text>
            <Text style={styles.gridValue}>
              {dayjs(date).format('DD [de] MMMM [del] YYYY')}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Horario</Text>
            <Text style={styles.gridValue}>
              {attention_init} - {attention_finish}
            </Text>
          </View>
        </View>
        <View style={styles.gridRow}>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>RUT Cliente</Text>
            {/* No eliminar el {} porque si se elimina no aparece el digito verificador */}
            <Text style={styles.gridValue}>
              {client_rut} {}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.gridLabel}>Estado Final</Text>
            <Text style={styles.gridValue}>{finish_state}</Text>
          </View>
        </View>
      </View>

      {/* Equipos Involucrados */}
      <View style={styles.dataSection}>
        <Text style={styles.sectionTitle}>Equipos Involucrados</Text>
        <View style={styles.fullWidthItem}>
          <Text style={styles.fullWidthValue}>
            {equipment.replace(/,/g, ' - ')}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default VoucherData;
